// extracted by mini-css-extract-plugin
module.exports = {"gradient":"Gradient_gradient__3PkNc","reversed":"Gradient_reversed__T4FOF"};